var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row embebido"},_vm._l((_vm.seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb),function(contenidoDeLaPaginaWeb){return _c('embed',{key:contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId,attrs:{"src":contenidoDeLaPaginaWeb.Vinculo}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1d70b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginaOficial/PaginaInformativa/Formatos/Embebido.vue
// module id = null
// module chunks = 